import { ApiResponse } from "@/interfaces/api-response";
import CustomizationForm, {
  Element,
} from "@/interfaces/customization-form.interface";
import apiClient from "@/utils/axios";

const getMany = async (params: {
  page: number;
  size: number;
  search?: string;
  excludeElements?: boolean;
  withElementsCount?: boolean;
}) => {
  const { page, size, search, excludeElements, withElementsCount } = params;
  const response = await apiClient.get<ApiResponse<CustomizationForm[]>>(
    `/customization-forms`,
    {
      params: {
        page,
        size,
        search,
        excludeVariantForms: true,
        excludeElements,
        withElementsCount,
      },
    },
  );
  return response.data;
};

const getOne = async (campaignId: string, id: string) => {
  const response = await apiClient.get<ApiResponse<CustomizationForm>>(
    `/campaigns/${campaignId}/customization-form/${id}`,
  );
  return response.data;
};

const getOneById = async (
  id: string,
  params?: {
    excludeElements?: boolean;
  },
) => {
  const response = await apiClient.get<ApiResponse<CustomizationForm>>(
    `/customization-forms/${id}`,
    { params },
  );
  return response.data;
};

const updateOneWithinCampaign = async (
  campaignId: string,
  id: string,
  data: Partial<CustomizationForm>,
) => {
  const response = await apiClient.put<ApiResponse<CustomizationForm>>(
    `/campaigns/${campaignId}/customization-form/${id}`,
    data,
  );
  return response.data;
};

const updateOneElement = async (
  campaignId: string,
  id: string,
  data: Element,
) => {
  const response = await apiClient.put<ApiResponse<CustomizationForm>>(
    `/campaigns/${campaignId}/customization-form/${id}/element`,
    data,
  );
  return response.data;
};

const createOne = async (data: {
  name: string;
  elements?: Element[];
  isVariantForm?: boolean;
}) => {
  const response = await apiClient.post<ApiResponse<CustomizationForm>>(
    `/customization-forms`,
    data,
  );
  return response.data;
};

const deleteOne = async (id: string) => {
  await apiClient.delete(`/customization-forms/${id}`);
};

const updateOneById = async (id: string, data: Partial<CustomizationForm>) => {
  const response = await apiClient.put<ApiResponse<CustomizationForm>>(
    `/customization-forms/${id}`,
    data,
  );
  return response.data;
};

const cloneOne = async (id: string) => {
  const response = await apiClient.post<ApiResponse<CustomizationForm>>(
    `/customization-forms/${id}/clone`,
  );
  return response.data;
};

const customizationFormApi = {
  getOne,
  updateOne: updateOneWithinCampaign,
  updateOneElement,
  getMany,
  getOneById,
  createOne,
  deleteOne,
  updateOneById,
  cloneOne,
};

export default customizationFormApi;
